import { Business, User } from 'model';

export function createCheckInTitle(user: User, business: Business): string {
	return `${user.username} checked in at ${business.name}`;
}
